// oxlint-disable-next-line no-restricted-imports -- Legacy migration debt — do not copy into new code.
import { Alert } from "@design-system/Alert/Alert";
import { ButtonWithLoader } from "@design-system/Button/ButtonWithLoader";
import { StandardModalBody } from "@design-system/Modal/Modal";
import { LockIcon } from "@icons";
import { PaymentElement } from "@stripe/react-stripe-js";
import { FC } from "react";
import styles from "./EnrollOrganizationForm.module.scss";
import {
    ENROLL_TO_ADD_CLIENTS_MESSAGE,
    EnrollAction,
    EnrollActionProps,
} from "./lib";
import { useEnrollmentFlow } from "./useEnrollmentFlow";

export const EnrollOrganizationForm: FC<EnrollActionProps> = ({ action }) => {
    const { paymentBusy, stripeError, checkoutError, handleEnroll } =
        useEnrollmentFlow({ action });

    return (
        <StandardModalBody className="overflow-y-auto">
            <form onSubmit={handleEnroll}>
                {action === EnrollAction.CREATE_CLIENT && (
                    <Alert variant="default" className={styles.section}>
                        {ENROLL_TO_ADD_CLIENTS_MESSAGE}
                    </Alert>
                )}
                {stripeError && (
                    <Alert variant="danger" className={styles.section}>
                        {stripeError.message}
                    </Alert>
                )}
                {checkoutError && (
                    <Alert variant="danger" className={styles.section}>
                        {checkoutError}
                    </Alert>
                )}
                <section className={styles.section}>
                    <PaymentElement />
                </section>
                <footer className={styles.footer}>
                    <ButtonWithLoader
                        variant="primary"
                        size="md"
                        type="submit"
                        loading={paymentBusy}
                        leftIcon={<LockIcon />}
                    >
                        Save payment details
                    </ButtonWithLoader>
                </footer>
            </form>
        </StandardModalBody>
    );
};
